import React from 'react';

const Toast = ({ toast, onClose }) => {
  return (
    <div className={`toast toast-${toast.type}`} role="alert">
      <div className="toast-content">
        {toast.type === 'success' && <span className="toast-icon success-icon">✓</span>}
        {toast.type === 'error' && <span className="toast-icon error-icon">✗</span>}
        {toast.type === 'info' && <span className="toast-icon info-icon">ℹ</span>}
        {toast.type === 'warning' && <span className="toast-icon warning-icon">⚠</span>}
        <span className="toast-message">{toast.message}</span>
      </div>
      <button className="toast-close" onClick={onClose}>×</button>
    </div>
  );
};

export default Toast;
